<fin-purchase-success
  [orderStatus$]="orderStatus$"
  [orderData$]="orderData$"
  [orderFetchInformation$]="orderFetchInformation$"
  (loadOrderErrorClick)="fetchOrder()"
  (ctaClick)="navigateToFrontPage()"
  class="col-f md-col-3-10"
></fin-purchase-success>
